import React from "react";
import { useSelector } from "react-redux";
import { getObjectByKey } from "../../../utils/utils";
import Widget from "../../features/widget/Widget";
import NavigateLink from "../../features/navigateLink/navigateLink";
import htcWidget from "../../../../assests/htc/htcWidget.png";
import classes from "./HtcWidget.module.css";

const HtcWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { platforms } = useSelector(state => state.uiData);
    const htc = getObjectByKey("htc", platforms)

    return (
        <NavigateLink link={htc?.link}>
            <Widget
                color="radial-gradient(50% 50% at 50% 50%, #39B6A9 0%, #174D3F 73.56%, #0B291A 100%)"
                title={texts.htc}
                titleColor={"white"}
                mainLink={htc?.link}
                className={classes.HtcWidget}
            >
                <div className={classes.HtcContent}>
                    <img src={htcWidget} alt="" className={classes.HtcImg} />
                </div>
            </Widget>
        </NavigateLink>

    );
};

export default HtcWidget;
